import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Segmented from "../../segmented/Segmented.jsx";
import ModalComponent from "../../modals/ModalComponent.jsx";
import Copy from "../../copy/Copy.jsx";
import Support from "../../../assets/Support.jsx";
import { ParentDetails } from "../../../api/request/parentDetails.js"
import { Spin, Carousel } from "antd";
import { GetActiveBanner } from "../../../api/request/header/getActiveBanner.js";


const CustomHeader = ({ collapsed, setCollapsed, isDrawerOpen, setIsDrawerOpen, ib, title }) => {

  const navigate = useNavigate();
  const { userDetails } = useSelector(state => state.user);
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue("--theme")?.trim();
  const [value, setValue] = useState(ib ? "IB Dashboard" : 'User Dashboard');
  const [fetched, setFetched] = useState(false);
  const [isOpenParentDetails, setIsOpenParentDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleParent, setIsVisibleParent] = useState(false);
  const [data, setData] = useState(null);
  const [isBanner, setIsBanner] = useState(false);
  const [bannerData, setBannerData] = useState(null);


  const getActiveBanner = async () => {
    try {
      const filterByCategory = value === "User Dashboard" ? 'user' : 'ibuser';
      const params = {
        filterByCategory,
        bannerViewType: 'web'
      };
      const { data } = await GetActiveBanner(new URLSearchParams(params).toString());
      if (data?.success) {
        setBannerData(data?.data[0]);
        data?.data[0] && setIsBanner(true);
      }
    }
    catch (error) {
    }
  }

  useEffect(() => {
    getActiveBanner();
  }, []);

  useEffect(() => {
    if (fetched) {
      if (value === 'IB Dashboard') {
        navigate('/ib/dashboard')
      } else if (value === 'User Dashboard') {
        navigate('/dashboard')
      }
    } else {
      setFetched(true)
    }
  }, [value]);

  useEffect(() => {
    getParentDetails();
  }, []);

  const getParentDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await ParentDetails();
      if (data?.success) {
        setData(data?.data);
        if (data?.data?.email) {
          setIsVisibleParent(true);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const openUserListModal = () => {
    setIsOpenParentDetails(true);
    if (data == null) {
      getParentDetails();
    }
  }
  const onChange = (currentSlide) => {
  };


  return (
    <div className="border-b p-4 ">
      <div className="h-10 flex justify-between items-center">
        <div className="flex items-center">
          <div className="md:hidden">
            <svg onClick={() => setCollapsed(!collapsed)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer hidden lg:block">
              <path fill-rule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
            </svg>
          </div>
          <svg onClick={() => setIsDrawerOpen(!isDrawerOpen)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer lg:hidden">
            <path fill-rule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
          </svg>
          <p className="ml-4 text-lg font-bold text-[#2F2B3D] uppercase hidden md:block">{title}</p>
          <div className="sm:ms-5 flex items-center">
            {bannerData?.bannerUrl
              ? <div className="rounded-full bg-secondary h-3 w-3 me-1 dotanim"></div> : ""}
            {bannerData?.bannerUrl
              ? <p onClick={e => setIsBanner(true)} className="sm:text-lg text-sm text-white bg-primary rounded-sm px-2 font-medium  cursor-pointer ">Offers</p> : ""}
          </div>
        </div>
        <div className="flex sm:gap-5 gap-2 items-center relative sm:text-lg text-sm">
          {
            (userDetails?.ibRequestStatus === 'Approved' && (window.location?.pathname).substring(0, 3) == '/ib') ?
              (<div className="bg-primary-light px-3 py-2 rounded-lg flex items-center justify-center ">
                <p className="me-2"><span className="xl:inline-block hidden">IB Code:</span> {userDetails?.referralCode}</p>
                <Copy text={`${window?.location?.origin}/?tab=register&ref=${userDetails?.referralCode}`} />
              </div>) : (
                <div>
                  {userDetails?.isShowParentDetail &&
                    <div className="flex justify-center items-center gap-2">
                      <p className="primary font-semibold">Parent Details</p>
                      <div onClick={openUserListModal}>
                        <Support />
                      </div>
                    </div>
                  }
                </div>
              )
          }
          {userDetails?.ibRequestStatus === 'Approved' &&
            <Segmented
              options={[
                { label: 'User Dashboard', value: 'User Dashboard', className: 'sm:block hidden' },
                { label: 'User', value: 'User Dashboard', className: 'sm:hidden block' },
                { label: 'IB Dashboard', value: 'IB Dashboard', className: 'sm:block hidden' },
                { label: 'IB', value: 'IB Dashboard', className: 'sm:hidden block' }
              ]}
              value={value}
              setValue={setValue}
            />
          }
        </div>
        <ModalComponent isOpen={isOpenParentDetails} setIsOpen={setIsOpenParentDetails} title='Parent Details' width={1000}>
          <div className='p-5'>
            {isLoading ? (
              <div className="flex justify-center flex-col my-5">
                <Spin size="large" />
                <p className="primary text-center mt-2">Loading...</p>
              </div>
            ) : (
              <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                <div>
                  <p className='text-base font-normal '>First Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{data?.firstName}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Last Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{data?.lastName}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Email</p>
                  <p className='text-xl primary font-semibold  mt-2'>{data?.email}</p>
                </div>
                {userDetails?.kycStatus === 'Approved' &&
                  <div>
                    <div className="lg:mt-6">
                      <button className="bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover duration-500" onClick={() => { setIsOpenParentDetails(false); navigate(`/inbox?ref=parent`) }}>Start Chat</button>
                    </div>
                  </div>
                }
              </div>
            )}
          </div>
        </ModalComponent>

        {/* getActiveBanner Modal */}
        <ModalComponent isOpen={isBanner} title={"Special Exclusive Offers"} setIsOpen={setIsBanner} width={700}>
          <Carousel autoplay autoplaySpeed={2000} >
            {bannerData?.bannerUrl?.map((item, index) => (
              <div key={index} >
                <img
                  src={item}
                  alt="banner"
                  className="rounded-lg"
                  preview={false}
                  style={{ width: '100%', height: '440px', objectFit: 'contain' }}
                />
              </div>
            ))}
          </Carousel>
          <p className="font-semibold text-lg mt-3 text-center">{bannerData?.bannerCaption}</p>
        </ModalComponent>
      </div>
    </div>
  );
};

export default CustomHeader;
